import offcanvas from 'bootstrap/js/dist/offcanvas'
import carousel from 'bootstrap/js/dist/carousel'
import toast from 'bootstrap/js/dist/toast'
import modal from 'bootstrap/js/dist/modal'
import collapse from 'bootstrap/js/dist/collapse'

export default defineNuxtPlugin(nuxtApp => {
  return {
    provide: {
      offcanvas,
      toast,
      carousel,
      modal,
      // collapse
      
    }
  }
})